(() => {
  if (window.gridoneEquipmentInquiryInstalled) return;
  window.gridoneEquipmentInquiryInstalled = true;
  const equipmentInterests = ['equipment', 'upgrade', 'kit', 'wheels', 'pedals', 'cockpit', 'motion', 'accessories'];
  function choose(panel, product, multiple = false) {
    const field = panel.querySelector('[data-go-selected-product]');
    const label = panel.querySelector('[data-go-selected-label]');
    const summary = panel.querySelector('[data-go-selected-summary]');
    if (!field || !product) return;
    if (panel.dataset.goDefaultProduct === undefined) panel.dataset.goDefaultProduct = field.value;
    field.value = product.slice(0, multiple ? 4000 : 500);
    panel.dataset.goSelectionSource = multiple ? 'rigg' : '';
    if (summary) summary.classList.toggle('gei-selected--multiple', multiple);
    const setup = panel.querySelector('[data-go-setup-select]');
    if (setup) setup.value = Array.from(setup.options).some(option => option.value === field.value) ? field.value : '';
    if (label) label.textContent = field.value;
    if (summary) summary.hidden = false;

  }
  function init() {
    const panel = document.querySelector('[data-go-equipment-panel]');
    if (panel && !panel.dataset.goInitialized) {
      panel.dataset.goInitialized = 'true';
      const setup = panel.querySelector('[data-go-setup-select]');
      if (setup) setup.addEventListener('change', () => {
        // The pedal picker owns this select and includes accessories in its summary.
        if (document.querySelector('[data-go-accessory-picker] [data-selection-group="pedals"]')) return;
        const brand = panel.dataset.goDefaultProduct || panel.querySelector('[data-go-selected-product]').defaultValue;
        choose(panel, setup.value || brand);
      });
      const params = new URLSearchParams(location.search);
      if (equipmentInterests.includes(params.get('interesse'))) choose(panel, params.get('produkt'));
    }
    const bar = document.querySelector('[data-go-equipment-bar]');
    if (!bar || bar.dataset.goInitialized) return;
    bar.dataset.goInitialized = 'true';
    let formVisible = false;
    function update() {
      const active = document.activeElement;
      const typing = active && active.matches('input,textarea,select,[contenteditable="true"]');
      const overlay = document.querySelector('dialog[open],details[open] [role="dialog"],[role="dialog"][aria-modal="true"]');
      bar.hidden = formVisible || Boolean(typing) || Boolean(overlay && overlay.getClientRects().length);
    }
    const form = panel && panel.querySelector('form');
    if (form && 'IntersectionObserver' in window) new IntersectionObserver(entries => {
      formVisible = entries.some(entry => entry.isIntersecting);
      update();
    }, {threshold: 0}).observe(form);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', () => requestAnimationFrame(update));
    document.addEventListener('toggle', update, true);
    window.addEventListener('resize', update, {passive: true});
    update();
  }
  document.addEventListener('gridone:equipment-selection', event => {
    const panel = document.querySelector('[data-go-equipment-panel]');
    const detail = event.detail;
    if (!panel || !detail || typeof detail.product !== 'string') return;
    const field = panel.querySelector('[data-go-selected-product]');
    if (!field) return;
    if (detail.product) choose(panel, detail.product, true);
    else if (panel.dataset.goSelectionSource === 'rigg') {
      choose(panel, panel.dataset.goDefaultProduct || 'Simracing-utstyr');
    }
    if (typeof detail.setup === 'string') {
      const setup = panel.querySelector('[data-go-setup-select]');
      if (setup) setup.value = detail.setup;
    }
    if (!detail.focus || !detail.product) return;
    const form = panel.querySelector('form');
    if (!form) return;
    form.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    const firstField = form.querySelector('input[name="contact[name]"]') || form.querySelector('input[type="email"]');
    if (firstField) firstField.focus({preventScroll: true});
  });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    const panel = document.querySelector('[data-go-equipment-panel]');
    if (!link || !panel || !panel.querySelector('input[type="email"]')) return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin || !url.pathname.endsWith('/pages/kontakt') || !equipmentInterests.includes(url.searchParams.get('interesse'))) return;
    event.preventDefault();
    choose(panel, url.searchParams.get('produkt'));
    const form = panel.querySelector('form');
    form.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    const firstField = form.querySelector('input[name="contact[name]"]') || form.querySelector('input[type="email"]');
    firstField.focus({preventScroll: true});
  });
  document.addEventListener('submit', event => {
    const request = event.target.closest('.goa-inquiry-form');
    const panel = document.querySelector('[data-go-equipment-panel]');
    if (!request || !panel || !panel.querySelector('input[type="email"]')) return;
    event.preventDefault();
    const product = request.querySelector('[name="produkt"]');
    choose(panel, product ? product.value : 'GRID.ONE');
    const form = panel.querySelector('form');
    form.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    (form.querySelector('input[name="contact[name]"]') || form.querySelector('input[type="email"]')).focus({preventScroll: true});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();



